module.exports = __webpack_public_path__ + "static/media/nonveg-icon.d9d2951b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nonveg-icon.svg
// module id = 596
// module chunks = 11